import { ErrorHandler, inject, Injectable } from "@angular/core";
import { catchError, Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { CustomHeader } from "../models/header.enum";
import { serializeError } from "serialize-error";
import { environment } from "../../../environments/environment";
import { AuthService } from './auth.service';

@Injectable()
export class ErrorService implements ErrorHandler {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);


  handleError(error: unknown) {
    console.log('<==================== Error from global error handler ====================>');
    console.error(error);
    console.log('<=============================== End =====================================>');
    if (environment.name !== 'local') {
      this.logException(error).subscribe(
        resp => console.log('Error reported successfully', resp),
      );
    }
  }


  logException(error: unknown): Observable<void> {

    const ex = [{
      type: 'application',
      error: serializeError(error),
      user: this.authService.email(),
      localtime: new Date().toLocaleTimeString('pl-PL'),
      env: environment.name,
      version: environment.version,      
      location: window.location,
      url: window.location.href,
      user_agent: window.navigator.userAgent,
    }];

    return this.http.post<void>(`${environment.urls.reportingApi}default`, ex, { headers: { [CustomHeader.SkipNotificationHeader]: '' } }).pipe(
      catchError(error => of(error))
    );
  }


  logData(log: string): Observable<void> {
    return this.http.post<void>(`${environment.urls.reportingApi}default`, log, { headers: { [CustomHeader.SkipNotificationHeader]: '' } });
  }

}